

export const WORKFLOW_ROUTES = [
  {
    path: "workflowOverview",
    name: "workflowOverview",
    component: () =>
        import(/* webpackChunkName: "workflow" */ "@/modules/workflow/overview/layout/WorkflowOverview"),
    children: [
      {
        path: "workflowDashboard",
        name: "workflowDashboard",
        component: () =>
            import(/* webpackChunkName: "workflow" */ "@/modules/workflow/overview/SubLayout/WorkflowDashboard")
      },
      {
        path: "workflowBoardOverview",
        name: "workflowBoardOverview",
        component: () =>
            import(/* webpackChunkName: "workflow" */ "@/modules/workflow/board/layouts/BoardLayout")
      },
      {
        path: "workflowProcess",
        name: "workflowProcess",
        component: () =>
            import(/* webpackChunkName: "workflow" */ "@/modules/workflow/overview/SubLayout/WorkflowProcess")
      },
      {
        path: "workflowPermissions",
        name: "workflowPermissions",
        component: () =>
            import(/* webpackChunkName: "workflow" */ "@/modules/workflow/overview/SubLayout/WorkflowPermissions")
      },
      {
        path: "workflowRecordsTable",
        name: "workflowRecordsTable",
        component: () =>
            import(/* webpackChunkName: "workflow" */ "@/modules/workflow/overview/SubLayout/WorkflowRecordTable")
      },
      {
        path: "workflowRecords",
        name: "workflowRecords",
        component: () =>
            import(/* webpackChunkName: "workflow" */ "@/modules/workflow/overview/SubLayout/WorkflowRecords")
      },
      {
        path: "workflowSettings",
        name: "workflowSettings",
        component: () =>
            import(/* webpackChunkName: "workflow" */ "@/modules/workflow/overview/SubLayout/WorkflowSettings")
      }
    ]
  },
  {
    path: "templateBuilderForm",
    name: "templateBuilderForm",
    component: () =>
        import(/* webpackChunkName: "workflow" */ "@/modules/workflow/formBuilder/components/forms/TemplateBuilderForm")
  },
  {
    path: "workflowRecordForm/:workflowRecordID",
    name: "workflowRecordForm",
    component: () =>
        import(/* webpackChunkName: "workflow" */ "@/modules/workflow/records/components/forms/RecordForm")
  },
  {
    path: "workflowBoard",
    name: "workflowBoard",
    component: () =>
        import(/* webpackChunkName: "workflow" */ "@/modules/workflow/board/layouts/BoardLayout")
  },
  {
    path: "templateFillForm",
    name: "templateFillForm",
    component: () =>
        import(/* webpackChunkName: "workflow" */ "@/modules/workflow/inspections/layouts/TemplateFillForm")
  },
  {
    path: "workflowTableEditor",
    name: "workflowTableEditor",
    component: () =>
        import(/* webpackChunkName: "workflow" */ "@/modules/workflow/dataTables/layouts/WorkflowTableEditor")
  },
  {
    path: "recordTableLayout",
    name: "recordTableLayout",
    component: () =>
        import(/* webpackChunkName: "workflow" */ "@/modules/workflow/records/layouts/RecordTableLayout")
  },
  {
    path: "workflowRecordOverview/:workflowRecordID",
    name: "workflowRecordOverview",
    component: () =>
        import(/* webpackChunkName: "workflow" */ "@/modules/workflow/records/layouts/WorkflowRecordOverview"),
  }
];
